<template>
  <section class="tomas-booking tomas-booking-shop container">
    <ClientOnly>
      <TomasWidget :type="TomasWidgetType.shop" />
    </ClientOnly>
  </section>
</template>

<script lang="ts" setup>
import { TomasWidgetType } from '~/layers/tomasBooking/components/TomasWidget/types'

defineBlokkliFragment({
  name: 'tomas_shop',
  label: 'Tomas Shop',
  chunkName: 'rare',
  editor: {
    noPreview: true,
  },
})
</script>
